// useDashboardHooks.js
import { useCallback, useState } from 'react';
import { fetchLatestSensorData } from "../utils/mqttUtils"; 
import { checkMqttCard } from "../utils/cardUtils";
import { setMqttAddresses } from "../utils/mqttUtils";
import { loadCardDataDBCache } from "../utils/apiUtils";
import * as cacheUtils from "./cacheUtils";

export const useFetchAndUpdateCards = (userVal, setCards, setIsDataLoading, setLastUpdated) => {
    return useCallback(async () => {
        if (!userVal) return;

        setIsDataLoading(true);
        try {
            const {data: loadedCards } = await loadCardDataDBCache(userVal);

            const updatedCards = loadedCards.map(card => {
                const macAddress = card.macAddress;

                if (checkMqttCard(macAddress)) {
                    setMqttAddresses(macAddress);
                }

                return card;
            });

            setCards(updatedCards);
            setLastUpdated(new Date());
            setIsDataLoading(false);
        } catch (error) {
            console.error("Error fetching and updating cards:", error);
            setIsDataLoading(false);
        }
    }, [userVal, setCards, setIsDataLoading]);
};

export const getMqttData = async (macAddress) => {
    const latestData = await fetchLatestSensorData(macAddress);
    const dataMap = {};
    let mostRecentTimestamp = null;

    let i = 0;
    latestData.forEach(data => {
        dataMap[i] = data.value;
        if(!mostRecentTimestamp) {
            mostRecentTimestamp = data.timestamp;
        }
        i+=1;
    })

    return {
        temperature: dataMap[0] || null,
        humidity: dataMap[1] || null,
        pressure: dataMap[2] || null,
        distance: dataMap[3] || null,
        timestamp: mostRecentTimestamp
    };
}

// Custom hook to manage card data
export const useCard = (macAddress, initialCard) => {
    return useState(() => {
        try {
            const cached = cacheUtils.get(macAddress);
            if (cached?.card) {
                return { ...cached.card, ...initialCard };
            }
            return initialCard;
        } catch (err) {
            console.error('Error initializing card state:', err);
            return initialCard;
        }
    });
};